import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { getIcon } from 'helpers';

const PostCategoryChip = ({ category }) => {
	const theme = useTheme();
	const useStyles = makeStyles(() => ({
		postCategoryChipRoot: {
			fontFamily: theme.font.default,
			fontSize: '16px',
			margin: '8px 0 24px',
			'& > div > span': {
				display: 'flex',
				alignItems: 'center',
			},
		},
		postCategoryChipIcon: {
			width: '16px',
			height: '16px',
			color: theme.palette.primary.main,
			marginRight: '8px',
		},
	}));
	const classes = useStyles();
	const IconComponent = getIcon(category);

	return (
		<div className={classes.postCategoryChipRoot}>
			<Chip
				label={
					<>
						<IconComponent className={classes.postCategoryChipIcon} />
						<span className={classes.postCategoryChipLabel}>
							{category.label?.toUpperCase?.()}
						</span>
					</>
				}
			/>
		</div>
	);
};

export default PostCategoryChip;
